var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProjectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28172 6.15616C8.28172 5.8757 8.05438 5.64835 7.77391 5.64836L2.54345 5.64841C2.26298 5.64841 2.03563 5.87576 2.03563 6.15623C2.03562 6.43669 2.26297 6.66404 2.54343 6.66403L7.7739 6.66398C8.05436 6.66398 8.28171 6.43663 8.28172 6.15616Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54342 7.67966C2.26296 7.67966 2.0356 7.90701 2.0356 8.18748C2.0356 8.46794 2.26294 8.69528 2.54341 8.69528L5.72005 8.69525C6.00052 8.69525 6.22787 8.4679 6.22787 8.18743C6.22787 7.90697 6.00053 7.67962 5.72007 7.67963L2.54342 7.67966Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77394 3.61711L2.54347 3.61716C2.26301 3.61716 2.03566 3.84451 2.03565 4.12498C2.03565 4.40544 2.263 4.63279 2.54346 4.63278L7.77393 4.63273C8.05439 4.63273 8.28174 4.40538 8.28174 4.12491C8.28175 3.84445 8.0544 3.6171 7.77394 3.61711Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3129 11.539L10.313 2.60146C10.313 1.48143 9.40183 0.570217 8.2818 0.570228L2.03853 0.570292C0.918497 0.570303 0.00726653 1.48153 0.00725188 2.60156L0.00713501 11.5391C0.00712037 12.6591 0.918327 13.5703 2.03836 13.5703L8.16596 13.5702L8.28163 13.5702C9.28766 13.5702 10.1252 12.835 10.2853 11.8737C10.3035 11.7648 10.3129 11.653 10.3129 11.539ZM2.03837 12.5547L8.16598 12.5546L8.16869 12.5546L8.28164 12.5546C8.84117 12.5546 9.29648 12.0998 9.29728 11.5404L9.29728 11.539L9.2974 2.60147C9.29741 2.04145 8.8418 1.58585 8.28179 1.58585L2.03851 1.58592C1.47898 1.58592 1.02367 2.04075 1.02288 2.6001L1.02288 2.60155L1.02276 11.539C1.02275 12.0991 1.47836 12.5547 2.03837 12.5547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProjectWhite);
export default __webpack_public_path__ + "static/media/myProjectWhite.ce742c3739db623d993cafc16d48a7d3.svg";
export { ForwardRef as ReactComponent };